import CaracteristiqueDetailController from './caracteristique.detail.controller';

export default {
    template: require('./caracteristique.detail.tpl.html'),
    controller: CaracteristiqueDetailController
};
